export default __webpack_public_path__ + "static/media/carosello3.ba704440.png";